import React from 'react';
import PersonalInfoItem from '../personal-info/PersonalInfoItem';
import '../personal-info/PersonalInfo.scss';

const PasswordInfoBlock = () => {    
    return (
        <div className="hrb-profile-personal-container">
            <PersonalInfoItem title='profile.password_info.password' value="●●●●●●●●" />
        </div>
    );
}

export default PasswordInfoBlock;